import { GetAssignedBucket } from '@carvana/purchase-helpers';

export const bucketUserInExperiment = async experimentName => {
  const experiment = {}
  return GetAssignedBucket({
    environment: process.env.NODE_ENV,
    experimentName
  })
    .then(res => {
      experiment[experimentName] = res.assignedBucket
      return experiment;
    })
    .catch(() => {
      experiment[experimentName] = 'control'
      return experiment;
    });
};

const InProgressActions = async res => {
  if (res?.status?.steps?.gapWaiver?.isEnabled) {
    const experiment = await bucketUserInExperiment('ptp-step-order-2022');
    res.experiments = Object.assign(res.experiments, experiment);
  }

  return Promise.resolve(res);
};

export default InProgressActions;
